import { createExclusionGroupFcmConfig } from '../shared/builders/exclusionGroup';
import type { FcmConfig } from '../shared/types';

const { name, normalizer, defaultValue } = createExclusionGroupFcmConfig('promote_or_share_combo_exclusion_group');

export const FCM_PROMOTE_OR_SHARE_COMBO_EXCLUSION_GROUP: FcmConfig<typeof defaultValue, typeof defaultValue> = {
	name,
	normalizer,
	defaultValue,
	owner: 'squad-koi',
	scope: 'corgi-front-end',
	context: 'Combo (promote_or_share) page',
	description:
		'Exclusion group for CHANGE-96755: keeps a session bucketed into at most one of promote_share_on_combo_experiment, psf_combo_sticky_cta_and_copy_experiment, and psf_combo_signature_count_experiment. Defaults to no members (all experiments effectively disabled) until weights are set via this admin page. Weights are shares of all sessions on this page, not shares of sessions eligible for each experiment — promote_share_on_combo_experiment is US-only, so non-US sessions allocated to it by weight land in neither experiment. Do not change member weights or order while any of these experiments is actively collecting data: treatment is sticky per session UUID, so doing so can flip already-treated sessions into another bucket without undoing their original treatment, double-counting them. Start a new experiment name instead.',
	import: false,
	template: {
		members: [
			{ experimentId: 'promote_share_on_combo_experiment', weight: 0.5 },
			{ experimentId: 'psf_combo_sticky_cta_and_copy_experiment', weight: 0.5 },
		],
	},
};
